require('./dist/smart-table.js');
module.exports = 'smart-table';


//////////////////
// WEBPACK FOOTER
// ./~/angular-smart-table/index.js
// module id = 413
// module chunks = 0